import { API_URL, getCachedSessionId } from 'src/services/common';

import { fetchMaintenanceResponseData } from './interfaces/fetchMaintenanceResponseData.interface';
import { api } from '../../../../util/axios-instance';

export const fetchMaintenance = async (params: {
  orderBy: string;
  orderDirection: string;
  page: string;
  pageSize: string;
  projectId: string;
  search: string;
}): Promise<fetchMaintenanceResponseData | undefined> => {
  const { projectId, page, pageSize, orderBy, orderDirection, search } = params;

  const response = await api.get<fetchMaintenanceResponseData>(
    `${API_URL}/v1/project/${projectId}/provider/maintenance?page=${page}&limit=${pageSize}&orderBy=${orderBy}&orderDirection=${orderDirection}&search=${search}`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};

export const fetchMaintenanceCSV = async (params: { projectId: string }) => {
  const { projectId } = params;

  const response = await api.get(`${API_URL}/v1/project/${projectId}/provider/maintenance/csv`, {
    headers: { 'x-session-id': getCachedSessionId() },
    responseType: 'blob'
  });

  return response.data;
};
